<template>
  <div class="monthly-container-throughput-drill-through-main">
    <div class="selection-filter">
      <div class="left-container" style="width: 100%">
        <div class="row">
          <div style="width : 50%;">
            <span> Job Date:&nbsp;{{ fromDate }} to {{toDate}} </span>
          </div>
          <div>
            <span>System:&nbsp; {{ selectedSystemInfo }}</span>
          </div>
        </div>
        <div class="row">
          <div style="width : 50%;">
            <span>Customer:&nbsp;{{ selectedCustomerInfo }}</span> 
          </div>
          <div>
            <span>Shipper/Consignee:&nbsp;{{selectedShprCsgnInfo}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <span>Job Type:&nbsp;{{selectedJobInfo}}</span>
          </div>
        </div>
      </div>
      <div class="right-container"> 
        <span style="margin-left: 10px">Last Refreshed: {{refreshDate}}</span>
      </div>
    </div>
    <div class="drill-through-body">
      <TableBox :title="tableTitle" :tableData="drillThroughDetails" :dataType="drillThroughDataType" :maxSelection="-1" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
  },
  computed: {
  },
  data: function() {
    return {
      drillThroughDetails: [],
      tableTitle: '',
      drillThroughDataType: {},
      fromDate: '',
      toDate: '',
      selectedJobInfo: '',
      selectedSystemInfo: '',
      selectedCustomerInfo: '',
      selectedShprCsgnInfo: '',
      refreshDate: '',
    };
  },
  props: {
  },
  methods: {
  },
  mounted() {
    var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
    this.drillThroughDetails = details.data;
    
    var keys = Object.keys(this.drillThroughDetails[0]);
    var jsonString = '{';
    var temp = "";

    this.fromDate = details.filter.fromDate;
    this.toDate = details.filter.toDate;
    this.selectedSystemInfo = details.filter.system;
    this.selectedJobInfo = details.filter.jobtype == 'ALL' ? 'All' : details.filter.jobtype ;
    this.selectedCustomerInfo = details.filter.customer ? details.filter.customer : 'All';
    this.selectedShprCsgnInfo = details.filter.shprCsgn ? details.filter.shprCsgn : 'All';
    this.refreshDate = details.filter.refreshDate;

    switch (details.rptType) {
      case 'BY_MONTH_SZTYPE':
        for (var i = 0; i < keys.length; i++) {
          if ( i == 0 ) { temp = "\"" + keys[i] + "\": \"string\"" }
          else { temp = ", \"" + keys[i] + "\": \"number\"" }
          jsonString = jsonString + temp;
        }
        jsonString = jsonString + "}";
        this.drillThroughDataType = JSON.parse(jsonString);
        this.tableTitle = 'Monthly Container Throughput Report';
        break;
      default:
        break;
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.monthly-container-throughput-drill-through-main {
  font-size: 12px;
  padding: 5px 5px 5px 45px;
  height: 90%;
  width : 90%;

  > .drill-through-body {
    background-color: white;
    height: 90%;
    border-radius: 5px;
    padding: 5px;
    overflow: auto;
  }

  > .selection-filter { 
    background-color: white;
    border-radius: 5px;
    padding: 5px 10px 5px 15px;
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 0 5px 0;

    >.left-container{
      >.row{
        display: flex;
        flex-wrap: wrap;
        padding-left: 10px;
        text-overflow: ellipsis;
      }
    }
    
    > .right-container {
      height: 100%;
      min-width: 250px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
    }
  }
}
</style>